/* GENERATED FILE */
import type { ReactElement, FC } from 'react';
import { Path } from 'react-native-svg';
import { type IconWeight } from '../lib';

export default new Map<
  IconWeight,
  ReactElement | FC<{ duotoneColor?: string; duotoneOpacity?: number }>
>([
  [
    'bold',
    <>
      <Path d="m250.73 122.63-40-80A12 12 0 0 0 200 36H56a12 12 0 0 0-10.73 6.63l-40 80A12 12 0 0 0 4 128v56a20 20 0 0 0 20 20h208a20 20 0 0 0 20-20v-56a12 12 0 0 0-1.27-5.37M96.58 60l8 16H83.42l-8-16Zm48 0 8 16h-21.16l-8-16Zm-41.16 56-8-16h21.16l8 16Zm48 0-8-16h21.16l8 16Zm48 0-8-16h21.16l8 16Zm1.16-40h-21.16l-8-16h21.16ZM28 130.83l28-56 28 56V180H28ZM108 180v-40h120v40Z" />
    </>,
  ],
  [
    'duotone',
    ({
      duotoneColor,
      duotoneOpacity,
    }: {
      duotoneColor?: string;
      duotoneOpacity?: number;
    }) => (
      <>
        <Path
          d="M240 128H96L56 48h144Z"
          opacity={duotoneOpacity}
          fill={duotoneColor}
        />
        <Path d="m247.16 124.42-40-80A8 8 0 0 0 200 40H56a8 8 0 0 0-7.16 4.42l-40 80A8.1 8.1 0 0 0 8 128v56a16 16 0 0 0 16 16h208a16 16 0 0 0 16-16v-56a8.1 8.1 0 0 0-.84-3.58M99.06 56l12 24H80.94l-12-24Zm48 0 12 24h-30.12l-12-24Zm-46.12 64-12-24h30.12l12 24Zm48 0-12-24h30.12l12 24Zm48 0-12-24h30.12l12 24Zm10.12-40h-30.12l-12-24h30.12ZM24 129.89l32-64 32 64V184H24ZM104 184v-48h128v48Z" />
      </>
    ),
  ],
  [
    'fill',
    <>
      <Path d="m247.16 124.42-40-80A8 8 0 0 0 200 40H56a8 8 0 0 0-7.16 4.42l-40 80A8.1 8.1 0 0 0 8 128v56a16 16 0 0 0 16 16h208a16 16 0 0 0 16-16v-56a8.1 8.1 0 0 0-.84-3.58M99.06 56l12 24H80.94l-12-24Zm48 0 12 24h-30.12l-12-24Zm-46.12 64-12-24h30.12l12 24Zm48 0-12-24h30.12l12 24Zm48 0-12-24h30.12l12 24Zm10.12-40h-30.12l-12-24h30.12ZM104 184v-48h128v48Z" />
    </>,
  ],
  [
    'light',
    <>
      <Path d="m245.37 125.32-40-80A6 6 0 0 0 200 42H56a6 6 0 0 0-5.37 3.32l-40 80A6.1 6.1 0 0 0 10 128v56a14 14 0 0 0 14 14h208a14 14 0 0 0 14-14v-56a6.1 6.1 0 0 0-.63-2.68M99.71 122l-14-28h34.58l14 28Zm.58-68 14 28H79.71l-14-28Zm48 0 14 28h-34.58l-14-28Zm-.58 68-14-28h34.58l14 28Zm48 0-14-28h34.58l14 28Zm14.58-40h-34.58l-14-28h34.58ZM22 184v-54.58l34-68 34 68V186H24a2 2 0 0 1-2-2m210 2H102v-52h132v50a2 2 0 0 1-2 2" />
    </>,
  ],
  [
    'regular',
    <>
      <Path d="m247.16 124.42-40-80A8 8 0 0 0 200 40H56a8 8 0 0 0-7.16 4.42l-40 80A8.1 8.1 0 0 0 8 128v56a16 16 0 0 0 16 16h208a16 16 0 0 0 16-16v-56a8.1 8.1 0 0 0-.84-3.58M99.06 56l12 24H80.94l-12-24Zm48 0 12 24h-30.12l-12-24Zm-46.12 64-12-24h30.12l12 24Zm48 0-12-24h30.12l12 24Zm48 0-12-24h30.12l12 24Zm10.12-40h-30.12l-12-24h30.12ZM24 129.89l32-64 32 64V184H24ZM104 184v-48h128v48Z" />
    </>,
  ],
  [
    'thin',
    <>
      <Path d="m243.58 126.21-40-80A4 4 0 0 0 200 44H56a4 4 0 0 0-3.58 2.21l-40 80A4 4 0 0 0 12 128v56a12 12 0 0 0 12 12h208a12 12 0 0 0 12-12v-56a4 4 0 0 0-.42-1.79M98.47 124l-16-32h39.06l16 32Zm3.06-72 16 32H78.47l-16-32Zm48 0 16 32h-39.06l-16-32Zm-3.06 72-16-32h39.06l16 32Zm48 0-16-32h39.06l16 32Zm19.06-40h-39.06l-16-32h39.06ZM20 184v-55.06l36-72 36 72V188H24a4 4 0 0 1-4-4m212 4H100v-56h136v52a4 4 0 0 1-4 4" />
    </>,
  ],
]);
